import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Badge,
} from "@chakra-ui/react";
import axios from "axios";
// Definir la interfaz para los turnos
interface Turno {
  ID: number;
  Folio: string;
  Area: string;
  FechaCreacion: string;
  Estado: string;
  UsuarioAsignado: string | null;
  Notas: string | null;
  FechaAtencion: string | null;
  CajaID: number | null;
}



const TurnosRealTime = () => {
  const [turnosPendientes, setTurnosPendientes] = useState<Turno[]>([]);

//  const [turnosPendientes, setTurnosPendientes] = useState<string[]>([]);
  const [turnosAtendidos, setTurnosAtendidos] = useState<{ [key: string]: string }>({});
  const [cajas, setCajas] = useState<{ ID: number; NumeroCaja: number; Estado: string; PrefijosPermitidos: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [turnosAtendidosAnteriores, setTurnosAtendidosAnteriores] = useState<{ [key: string]: string }>({});

  // Función para reproducir sonido de notificación
  const reproducirSonido = () => {
    try {
      // Usar el API de Web Audio para crear un tono de notificación
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Configurar el sonido (tono de campana)
      oscillator.frequency.value = 800; // Frecuencia en Hz
      oscillator.type = 'sine';

      // Configurar el volumen con fade out
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

      // Reproducir sonido
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.error("Error al reproducir sonido:", error);
    }
  };

  // Obtener turnos y cajas desde la API
  const fetchData = async () => {
    //setLoading(true);
    try {
      const [turnosResponse, cajasResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/turnos`),
        axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cajas`),
      ]);
  
      // Procesar turnos
      if (turnosResponse.data) {
        const { proximosTurnos, turnosEnAtencion } = turnosResponse.data;

        // ⚠️ Corrección: Guardar los objetos completos en lugar de solo `Folio`
        setTurnosPendientes(proximosTurnos);

        // Crear un objeto con los turnos en atención { CajaID: Folio }
        const atendidos: { [key: string]: string } = {};
        turnosEnAtencion.forEach((turno: any) => {
          atendidos[`Caja ${turno.CajaID}`] = turno.Folio;
        });

        // Detectar si hay nuevos turnos en atención
        const cajasNuevas = Object.keys(atendidos).filter(
          (caja) => !turnosAtendidosAnteriores[caja] || turnosAtendidosAnteriores[caja] !== atendidos[caja]
        );

        // Si hay nuevos turnos en atención, reproducir sonido
        if (cajasNuevas.length > 0 && Object.keys(turnosAtendidosAnteriores).length > 0) {
          reproducirSonido();
        }

        setTurnosAtendidos(atendidos);
        setTurnosAtendidosAnteriores(atendidos);
      }
  
      // Procesar cajas
      if (cajasResponse.data) {
        setCajas(cajasResponse.data);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };
  

  // Enviar turno al API asignando a una caja específica
  const asignarTurnoACaja = async (cajaID: number) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/turnos/asignar`, {
        cajaID, // Enviar el número de caja
      });

      if (response.data.message) {
        alert(response.data.message);
      } else {
        fetchData(); // Actualizar lista de turnos y cajas después de asignar
      }
    } catch (error) {
      console.error("Error al asignar el turno:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box p={4} pt={79} width="100%" textAlign="center">

      {loading ? (
        <Spinner size="xl" mt={4} />
      ) : (
        <VStack spacing={6} mt={4}>
          <Box p={4} bg="white" borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.200" width="100%">
            <Text fontSize="lg" fontWeight="bold" color="#681a2d" mb={4}>Turnos en Atención</Text>
            <Table variant="simple" size="sm" mt={2}>
              <Thead bg="gray.50">
                <Tr>
                  <Th color="#681a2d" fontWeight="bold" fontSize="sm">Caja</Th>
                  <Th color="#681a2d" fontWeight="bold" fontSize="sm">Turno</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.keys(turnosAtendidos).length > 0 ? (
                  Object.entries(turnosAtendidos).map(([caja, folio]) => (
                    <Tr key={caja} _hover={{ bg: "#bb8c5210" }}>
                      <Td>
                        <Badge bg="#bb8c52" color="white" fontSize="xs" borderRadius="full" px={2}>
                          {caja}
                        </Badge>
                      </Td>
                      <Td>
                        <Badge bg="#5b182b" color="white" fontSize="sm" borderRadius="md" px={3} py={1}>
                          {folio}
                        </Badge>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={2} textAlign="center">No hay turnos en atención.</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>

          <Box p={4} bg="white" borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.200" width="100%">
            <Text fontSize="lg" fontWeight="bold" color="#681a2d" mb={4}>Próximos Turnos ({turnosPendientes.length})</Text>
  <Table variant="simple" size="sm" mt={2}>
    <Thead bg="gray.50">
      <Tr>
        <Th color="#681a2d" fontWeight="bold" fontSize="sm">#</Th>
        <Th color="#681a2d" fontWeight="bold" fontSize="sm">Turno</Th>
        <Th color="#681a2d" fontWeight="bold" fontSize="sm">Fecha Creación</Th>
      </Tr>
    </Thead>
    <Tbody>
      {turnosPendientes.length > 0 ? (
        turnosPendientes.map((turno, index) => (
          <Tr key={turno.ID} _hover={{ bg: "#bb8c5210" }}>
            <Td>
              <Badge bg="#bb8c52" color="white" fontSize="xs" borderRadius="full">
                {index + 1}
              </Badge>
            </Td>
            <Td>
              <Badge bg="#681a2d" color="white" px={3} py={1} borderRadius="md" fontSize="sm">
                {turno.Folio}
              </Badge>
            </Td>
            <Td>
              <Text fontSize="sm" color="gray.600">
                {new Date(turno.FechaCreacion).toLocaleString()}
              </Text>
            </Td>
          </Tr>
        ))
      ) : (
        <Tr>
          <Td colSpan={3} textAlign="center">
            <Text color="gray.500" fontSize="sm">No hay turnos pendientes.</Text>
          </Td>
        </Tr>
      )}
    </Tbody>
  </Table>
            <HStack spacing={4} justifyContent="center" mt={4}>
              {cajas.map((caja) => (
                <Box 
                  key={caja.ID} 
                  textAlign="center"
                  borderWidth="1px"
                  borderColor="#bb8c52"
                  borderRadius="lg"
                  p={4}
                  bg="white"
                  boxShadow="sm"
                >
                  <Button
                    bg={caja.Estado === "Disponible" ? "#28a745" : "#dc3545"}
                    color="white"
                    _hover={{ 
                      bg: caja.Estado === "Disponible" ? "#218838" : "#c82333"
                    }}
                    onClick={() => asignarTurnoACaja(caja.ID)}
                    size="sm"
                  >
                    Caja {caja.NumeroCaja}
                  </Button>
                  <Box mt={2}>
                    {caja.PrefijosPermitidos.split(",").map((prefijo) => (
                      <Badge key={prefijo} bg="#bb8c52" color="white" mx={1} fontSize="xs" borderRadius="full">
                        {prefijo}
                      </Badge>
                    ))}
                  </Box>
                </Box>
              ))}
            </HStack>
          </Box>


        </VStack>
      )}
    </Box>
  );
};

export default TurnosRealTime;
